import React, { useState } from 'react';
import fallBackImg from '../assets/images/siteImg/laptop-checkmark.svg'; 

interface ImageContentProps {
  imageUrl: string;
  imageAlt?: string;
  additionalClasses?: string;
  fallbackImage?: string; 
}

const ImageContent: React.FC<ImageContentProps> = ({
  imageUrl,
  imageAlt = 'Image',
  additionalClasses = '',
  fallbackImage = {fallBackImg}, 
}) => {
  const [hasError, setHasError] = useState(false);

  if (!imageUrl || imageUrl.trim().length === 0) {
    return <p className="text-danger">⚠ Image URL is missing</p>;
  }

  return (
    <img
      src={hasError ? fallBackImg : imageUrl}
      alt={imageAlt}
      className={`img-fluid${additionalClasses ? ' ' + additionalClasses : ''}`}
      onError={() => setHasError(true)} 
    />
  );
};

export default ImageContent;
